export default __webpack_public_path__ + "static/media/INXC.951535d6.png";